import {Button} from 'components/system/Button'
import {useContactUsPath} from 'providers/EnvironmentProvider'
import {useCallback} from 'react'

export const ContactUs = () => {
  const contactUsPath = useContactUsPath()

  const onClick = useCallback(() => {
    window.location.href = contactUsPath
  }, [contactUsPath])

  return (
    <div className="p-12 flex flex-col bg-[#F1F2F3] rounded-lg">
      <div className="text-[22px] font-bold">Contact us</div>
      <div className="mt-2 mb-6">Please contact our support team and we will help you.</div>
      <Button.Primary.Orange onClick={onClick}>Contact</Button.Primary.Orange>
    </div>
  )
}
